<template>
    <div class="bg-white rounded-md shadow p-6 -mb-5 print:-mt-10">
        <h3 class="text-lg mb-4">
            You'll Pay
        </h3>
       <div v-if="cartData.promoPriceTotal" class="mb-4">
            <PricePerMonth :price="cartData.promoPriceTotal - discountAmount" />
            <span class="text-sm">Included local tax</span>
            <span class="font-bold">{{ toCurrency(cartData.taxes) }}</span>

            <div v-if="cartData.promoPriceTotal !== cartData.firstMonthTotal">
                    <span class="text-sm">
                        <span>First Month (includes install fee):</span>
                        <span class="font-bold text-salmon">{{ toCurrency(cartData.firstMonthTotal - discountAmount) }}</span>
                    </span>
            </div>
        </div>

        <p>
            <strong>You will shortly receive an email from us</strong>
            with a quick summary of your most recent order and what your billing statement will look like after the
            order has processed. The email will be sent to the email address provided during purchase.
        </p>
    </div>
</template>

<script>
import PricePerMonth from "@/atoms/PricePerMonth"
export default {
    name: "StatementInfo",
    components: {
        PricePerMonth,
    },
    props: {
        cartData: {
            type: Object,
            required: true
        },
        fmfAmount: {
            type: Number,
            required: true
        },
        discountAmount: {
            type: Number,
            required: true
        },
    },
    methods: {
        isInternetOnly(services) {
            // Check if there is only internet service
            return services.internet && !services.tv.length && !services.voice.length;
        },
    },
}
</script>

<style scoped>

</style>
